import api from '../../plugins/api';

const getCarcaseCar = (params) => {
  return api.get('/api/shop/getCarcaseCar', params);
};

export default getCarcaseCar;
